module.exports = __webpack_public_path__ + "img/no-events.21efccd8.png";